// extracted by mini-css-extract-plugin
module.exports = {"videos-container":"SearchVideosModal_videos-container__3p3ig","search-bar":"SearchVideosModal_search-bar__3HXHg"};